// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"a1a79354","362":"2d8a2616","497":"3c6a3f48","652":"196a23c0","944":"c3548ebf"}[chunkId] + ".chunk.js";
};